// @generated
// THIS FILE WAS AUTOMATICALLY GENERATED AND SHOULD NOT BE EDITED
/* eslint-disable */
import type * as Types from '../../../__generated-gql-types__/globalTypes';

import { gql } from '@apollo/client';
export type SchoolTagCoachFragment = {
  __typename?: 'Coach';
  id: string;
  educationExperiences?: Array<{
    __typename?: 'Education';
    isFeatured?: boolean | null;
    school: {
      __typename?: 'School';
      id: string;
      name: string;
      logoLink?: string | null;
    };
  }> | null;
  schoolAdmissionInfoList?: Array<{
    __typename?: 'SchoolAdmissionInfo';
    status?: Types.SchoolAdmissionStatus | null;
    school: {
      __typename?: 'School';
      id: string;
      name: string;
      logoLink?: string | null;
    };
  }> | null;
};

export const SchoolTagCoachFragmentDoc = gql`
  fragment SchoolTag_Coach on Coach {
    id
    educationExperiences {
      school {
        id
        name
        logoLink
      }
      isFeatured
    }
    schoolAdmissionInfoList {
      school {
        id
        name
        logoLink
      }
      status
    }
  }
`;
